import { texteVersHtml } from '@silex/shared';
import { useMemo } from 'react';

/**
 * Un texte du contenu rédigé, avec ses mathématiques DESSINÉES — jamais la
 * source LaTeX (chantier « manuel vivant », Φ-MV-1).
 *
 * Le contenu du manuel écrit ses formules en LaTeX restreint entre `\(` et
 * `\)` (MV-CNT-01). La console n'avait aucun rendu de formules : une capacité
 * de notion s'y serait lue « \(a^m \cdot a^n = a^{m+n}\) ».
 *
 * ─── Le moteur est celui du produit, pas un second ──────────────────────────
 *
 * `texteVersHtml` (`@silex/shared`, module `copie`) est ce qui rend déjà une
 * copie corrigée pour l'impression : même analyseur que l'application
 * (`analyserTexteLatex`), sortie en MathML, que le navigateur dessine. Une
 * formule que l'application refuserait de dessiner est REPLIÉE en prose, comme
 * dans l'application — on ne montre jamais de barre oblique inverse
 * (`DECISIONS-ARCHITECTE.md`, point 13 : « formules de la console : le moteur
 * de l'application, partagé »).
 *
 * ─── Pourquoi `dangerouslySetInnerHTML` est sûr ici ─────────────────────────
 *
 * Avec `FigureV2Web` (une figure dessinée par le moteur partagé), c'est le
 * seul endroit de la console qui l'emploie, et il n'injecte que la
 * sortie de `texteVersHtml` : la prose y est ÉCHAPPÉE caractère par caractère
 * (`echapperHtml`), et les seules balises produites sont celles du MathML,
 * construites depuis un arbre analysé — jamais recopiées du texte. Un contenu
 * qui porterait `<script>` s'afficherait tel quel, en lettres. L'import refuse
 * de toute façon tout balisage dans un texte du dossier.
 */
export function TexteMaths({ texte }: { readonly texte: string }) {
  const html = useMemo(() => texteVersHtml(texte, true), [texte]);
  return <span className="texte-maths" dangerouslySetInnerHTML={{ __html: html }} />;
}
